export default "__VITE_ASSET__56c977b0__"